import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  FaBriefcase,
  FaBuilding,
  FaCalculator,
  FaCalendarAlt,
  FaChalkboardTeacher,
  FaFolderOpen,
  FaHandshake,
  FaMoneyBill,
  FaPenSquare,
  FaPhotoVideo,
  FaRegStar,
  FaBirthdayCake,
  FaUserAlt,
  FaAddressCard,
} from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-cube";
import AnuncioCard from "./AnuncioCard";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import ComentariosAnunciosModal from "../dialogs/ComentariosAnunciosModal";

const AnunciosHomeContainer = ({ anuncios }) => {
  const [anuncioModal, setAnuncioModal] = useState({
    active: false,
    anuncio: null,
  });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Add a listener for changes to the screen size
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    // Set the initial value of the `isMobile` state variable
    setIsMobile(mediaQuery.matches);
    // Define a callback function to handle changes to the media query
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    // Add the callback function as a listener for changes to the media query
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    // Remove the listener when the component is unmounted
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);
  return (
    <div className=" ">
      <ComentariosAnunciosModal
        setModal={setAnuncioModal}
        active={anuncioModal.active}
        anuncio={anuncioModal.anuncio}
      />
      <Swiper
        className="relative z-0"
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={50}
        slidesPerView={isMobile ? 1 : 3}
        pagination={{ clickable: true }}
      >
        {anuncios.map((anuncio, index) => (
          <SwiperSlide className={` h-full  max-w-xs`} key={anuncio.id}>
            <AnuncioCard
            key={anuncio.id}
              anuncio={anuncio}
              anuncios={anuncios}
              setAnuncioModal={setAnuncioModal}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default AnunciosHomeContainer;
